import { Component, OnInit, ElementRef } from "@angular/core";
import { PortalAdminService } from "../../services/portal-admin-service/portal-adimin.service";
import { RecommitOrder } from "../../models/recommit-order.model";
import { HttpErrorResponse } from "@angular/common/http";
import { Router } from "@angular/router";
import { MatTableDataSource } from "@angular/material/table";
import { ViewChild } from "@angular/core";

@Component({
    selector: "pa-recommit-process",
    templateUrl: "./recommit-process.component.html",
    styleUrls: ["./recommit-process.component.scss"],
    standalone: false
})
export class RecommitProcessComponent implements OnInit {
  @ViewChild("uploadFile") uploadFile: ElementRef;

  isLoading: boolean;
  isUploadFileSuccess = false;
  isFileSelected = false;
  isValidExcelFile = false;
  isExcelFile = false;
  dataExist = false;
  recordsSaved = false;
  fileName = "Select file...";
  errorMessage = "";
  hasFailedRecommits = false;

  recommitOrders: RecommitOrder[] = [];

  displayedColumns;

  dataSource: MatTableDataSource<RecommitOrder> = new MatTableDataSource([]);

  constructor(
    private portalAdminService: PortalAdminService,
    private router: Router
  ) {}

  ngOnInit() {
    this.displayedColumns = [
      "email",
      "createDate",
      "accountName",
      "salesOrderNumber",
    ];

    this.isLoading = true;

    this.portalAdminService.hasFailedRecommitOrders().subscribe(
      (hasFailed: boolean) => {
        this.hasFailedRecommits = hasFailed;
        this.isLoading = false;
      },
      (err: HttpErrorResponse) => {
        this.isLoading = false;

        console.log(err);

        if (err.status === 400) {
          this.errorMessage = err.error;
        } else if (err.status === 403 || err.status === 401) {
          this.router.navigate(["/access-denied"]);
        } else {
          this.router.navigate(["/error"]);
        }
      }
    );
  }

  fileChanged(event) {
    this.isLoading = true;
    const files = event.target.files;
    this.fileName = files[0].name;

    if (this.fileName.split(".").pop() === "xlsx") {
      this.isExcelFile = true;
      const formData = new FormData();
      formData.append(files[0].name, files[0]);

      this.portalAdminService.parseRecommitOrders(formData).subscribe(
        (recommitRes: RecommitOrder[]) => {
          if (recommitRes.length > 0) {
            this.dataExist = true;
          }

          this.recommitOrders = recommitRes;
          this.dataSource.data = this.recommitOrders;

          this.isValidExcelFile = true;
          this.isExcelFile = true;
          this.isLoading = false;
          this.isUploadFileSuccess = true;
          this.errorMessage = "";
        },
        (err: HttpErrorResponse) => {
          this.isLoading = false;

          console.log(err);

          if (err.status === 400) {
            this.errorMessage = err.error;
          } else if (err.status === 403 || err.status === 401) {
            this.router.navigate(["/access-denied"]);
          } else {
            this.router.navigate(["/error"]);
          }
        }
      );
    } else {
      this.isExcelFile = false;
      this.isValidExcelFile = false;
      this.isUploadFileSuccess = false;
      this.recommitOrders = [];
      this.dataSource.data = this.recommitOrders;
      this.dataExist = false;
      this.isLoading = false;
      this.errorMessage = "";
    }
  }

  clearData() {
    this.isExcelFile = true;
    this.isValidExcelFile = false;
    this.isUploadFileSuccess = false;
    this.isFileSelected = false;
    this.recordsSaved = false;
    this.recommitOrders = [];
    this.dataExist = false;
    this.uploadFile.nativeElement.value = null;
    this.dataSource.data = this.recommitOrders;
    this.fileName = "Select file...";
    this.errorMessage = "";
  }

  submitData() {
    this.isLoading = true;

    if (this.recommitOrders.length > 0) {
      this.portalAdminService
        .submitRecommitOrders(this.recommitOrders)
        .subscribe(
          (recommitRes: RecommitOrder[]) => {
            if (recommitRes.length > 0) {
              this.recordsSaved = true;
            }

            this.isLoading = false;
          },
          (err: HttpErrorResponse) => {
            this.isLoading = false;

            this.errorMessage = err.message;
            console.log(err);

            if (err.status === 403 || err.status === 401) {
              this.router.navigate(["/access-denied"]);
            } else {
              this.router.navigate(["/error"]);
            }
          }
        );
    }
  }

  navigateToFailedRecommits() {
    this.router.navigate(["/failed-recommits"]);
  }
}
